const LilDujourFeaturesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/0YHNqTEXdkHFzPKxFYFOn9?si=73f280f6e6424081" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - $tre$$ (feat. Lil Dujour)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3IAym27cx48RClaaVPghKA?si=b9532f9724fe412c" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Battle Bus (feat. Lil Dujour)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5WcMFgBGwAprkavtzpgT0d?si=d7750df71d3e4001" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-KSDnl3ihOK4mzmJM-n6cKLQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Dujour Speaks (feat. Lil Dujour)</strong><br/>
                (prod. Meauxminy & Geist)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1T220QwAqJRjLSiDfTI7Te?si=95d57ebd6acd489e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Los Angeles</strong><br/>
                (feat. Lil Dujour & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4qNn3LnOvarl3XqrOkoJWk?si=bf183cb7f04643b4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Hollywood Money</strong><br/>
                (feat. Lil Dujour, Sketchtheheathen & Rosie Grave)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/0SfqdQ0oeemdtmNvYgMkWc?si=825c8d441a7d429b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - City Moves</strong><br/>
                (feat. Lil Dujour, Zerow & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5mR9mkhJrHjdvKIL3Auow5?si=0798c6091b404175" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Crying on Melrose</strong><br/>
                (feat. Lil Dujour & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7bVUcxEG7dwUb6g9L1AWjF?si=2e1f804f16994785" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Why You Do Me Like Dat??</strong><br/>
                (feat. Lil Dujour)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7pfaMhMrwlQ2WLxuHPiZTM?si=455e8ceab55c4ea5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Personals</strong><br/>
                (feat. Lil Dujour & Sketchtheheathen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1T220QwAqJRjLSiDfTI7Te?si=d5bcb38cb66940a6" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e0226a51db3336033e0a90223ba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - Shakesum</strong><br/>
                (feat. Lil Dujour & Kewl Nast)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4N21qR6oV6xechdUj7PWRD?si=2a1f454a5ac247dc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-4zUzENh91AiOUYHZ-lfj4Hg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Killtheheretik - Glue (feat. Lil Dujour)</strong><br/>
                (prod. Halfblown)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1G9wfBsFdlhqLvufjbsAPS?si=602a7440282b4504" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02e1636759f4214070c4582b2f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lil Bauhaus - I Was Broke Last Weekend (feat. Lil Dujour)</strong><br/>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default LilDujourFeaturesStatic;